import { render } from "./addons.vue?vue&type=template&id=3ac9626f"
import script from "./addons.vue?vue&type=script&lang=js"
export * from "./addons.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__